import { useState } from 'react'

import { PlanPeriodDto } from 'core'

import { Button, Col, Dropdown, Icon, Menu, MenuItem, Modal, Row, SimpleRadio } from 'common/components'
import { formatYear, parseZoneFormat } from 'common/dateFormatters'

type HSAModalProps = {
  isHSAModalOpen: boolean
  onHSAModalClose: () => void
  hasMultiplePlanPeriod: boolean
  submitHSAChanges: (yearDropDownValue: string, hsaRadioOptionValue: string) => void
  selectedPlanPeriod: PlanPeriodDto
}

const HSAModal = ({
  isHSAModalOpen,
  onHSAModalClose,
  hasMultiplePlanPeriod,
  submitHSAChanges,
  selectedPlanPeriod,
}: HSAModalProps) => {
  const [isHSADropDownOpen, setISHSADropDownOpen] = useState<boolean>(false)
  const [hsaRadioOptionValue, setHsaRadioOptionValue] = useState<string>('')
  const [yearValueDropDown, setYearValueDropDown] = useState<string>('')

  const handleHSARadioValue = (value: string) => {
    setHsaRadioOptionValue(value)
    if (
      selectedPlanPeriod !== null &&
      formatYear(new Date(selectedPlanPeriod.startDate)) < formatYear(new Date(selectedPlanPeriod.endDate))
    ) {
      setISHSADropDownOpen(true)
    }
  }

  const handleYearValue = (e: { key: React.SetStateAction<any> }) => {
    setYearValueDropDown(e.key)
  }

  const showDate = (selectedPlanPeriod: PlanPeriodDto) =>
    hasMultiplePlanPeriod ? (
      <span>
        {parseZoneFormat(new Date(selectedPlanPeriod.startDate))} -{' '}
        {parseZoneFormat(new Date(selectedPlanPeriod.endDate))}{' '}
      </span>
    ) : (
      formatYear(new Date(selectedPlanPeriod.endDate))
    )

  const handleHSAModalClose = () => {
    setHsaRadioOptionValue('')
    setISHSADropDownOpen(false)
    setYearValueDropDown('')
    onHSAModalClose()
  }

  const menu = (
    <>
      {selectedPlanPeriod !== null &&
        formatYear(new Date(selectedPlanPeriod.startDate)) < formatYear(new Date(selectedPlanPeriod.endDate)) && (
          <Menu onClick={handleYearValue}>
            <MenuItem key={formatYear(new Date(selectedPlanPeriod.startDate))}>
              <span>{formatYear(new Date(selectedPlanPeriod.startDate))}</span>
            </MenuItem>
            {formatYear(new Date(selectedPlanPeriod.endDate)) !==
              formatYear(new Date(selectedPlanPeriod.startDate)) && (
              <MenuItem key={formatYear(new Date(selectedPlanPeriod.endDate))}>
                <span>{formatYear(new Date(selectedPlanPeriod.endDate))}</span>
              </MenuItem>
            )}
          </Menu>
        )}
    </>
  )
  return (
    <Modal
      visible={isHSAModalOpen}
      okButtonProps={{
        disabled: !hsaRadioOptionValue,
      }}
      onCancel={handleHSAModalClose}
      onOk={() => submitHSAChanges(yearValueDropDown, hsaRadioOptionValue)}
      closable
    >
      <div className="mb-8">
        Are you, your spouse, or an employer contributing to a health savings account (HSA) during the{' '}
        {showDate(selectedPlanPeriod)} plan year?
      </div>
      <SimpleRadio.Group>
        <Row gutter={[8, 8]}>
          <Col span={24} className="mb-4">
            <SimpleRadio value={'y'} onChange={() => handleHSARadioValue('y')}>
              Yes
            </SimpleRadio>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <SimpleRadio value={'n'} onChange={() => handleHSARadioValue('n')}>
              No
            </SimpleRadio>
          </Col>
        </Row>
      </SimpleRadio.Group>
      {isHSADropDownOpen && hasMultiplePlanPeriod && (
        <div className="mt-8">
          <Row className="mb-4">
            <Col span={24}>
              {hsaRadioOptionValue === 'y' ? (
                <span>During which tax year will you contribute to an HSA?</span>
              ) : (
                <span>
                  During which tax year will you <u>not</u> contribute to an HSA?
                </span>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
                <Button
                  className="ant-dropdown-link grey-link personal-dropdown p-0"
                  onClick={(e) => e.preventDefault()}
                >
                  {yearValueDropDown !== '' ? (
                    yearValueDropDown
                  ) : (
                    <span>
                      Select One
                      <Icon type="down" className="ml-8" />
                    </span>
                  )}
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      )}{' '}
    </Modal>
  )
}

export default HSAModal
